import React, { useContext, useState, useEffect } from 'react';
import {
    summaryHeadCellStyle,
    summaryHeadingStyle,
    summaryTextStyle,
    impactsDigitStyle,
    planSummaryContainerStyle,
    summaryTableStyle,
    summaryBaseCellStyle,
    summaryTargetCellStyle
} from './AirtimePlanningStyles';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { GetPlanCpts } from '../../../services/CampaignsDataService';
import { useModal } from '@adserve/adserve-react-components';
let mounted = false;

const PlanSummary = ({ hasPlan, planSummary, planId, stationId }) => {
    const { formatCurrency } = useContext(SystemSettingsContext);
    const { addMessage } = useModal();
    const [cpts, setCpts] = useState({ effectiveBaseCpt: 0, effectiveTargetCpt: 0 });

    const getCpts = async () => {
        if (!planId || planId === window.planId) {
            return;
        }
        try {
            const response = await GetPlanCpts(planId, window.emptyGuid);
            if (mounted) {
                setCpts(response);
            }
        } catch (err) {
            addMessage({
                message: `Failed to calculate CPT. ${err.response?.data}`,
                buttons: [{ text: window.translate('Ok') }]
            });
        }
    };
    useEffect(() => {
        GetPlanCpts(planId, stationId).then((response) => {
            setCpts(response);
        });
    }, [stationId]);

    useEffect(() => {
        mounted = true;
        getCpts();
        return () => {
            mounted = false;
        };
    }, [planId]);

    const getTotalValue = (fieldname) => {
        let total = 0;
        for (let i = 0; i < planSummary?.dayParts?.length; i++) {
            total += planSummary.dayParts[i][fieldname];
        }
        return total;
    };

    const getTotal = (fieldname) => {
        const total = getTotalValue(fieldname);
        return Math.round(total)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    return (
        <div style={planSummaryContainerStyle}>
            <table style={summaryTableStyle}>
                <thead>
                    <tr>
                        <th style={{ ...summaryHeadCellStyle, width: 243 }} />
                        <th style={summaryHeadCellStyle}>
                            <span style={summaryHeadingStyle}>{!hasPlan ? '' : window.translate('Total Spots')}</span>
                        </th>
                        <th style={summaryHeadCellStyle}>
                            <span style={summaryHeadingStyle}>
                                {!hasPlan ? (
                                    ''
                                ) : (
                                    <>
                                        <span>{window.translate('Total Impacts')} </span>
                                        <span style={impactsDigitStyle}>(000&#39;s)</span>
                                    </>
                                )}
                            </span>
                        </th>
                        <th style={summaryHeadCellStyle}>
                            <span style={summaryHeadingStyle}>{!hasPlan ? '' : window.translate('Overall OTH')}</span>
                        </th>
                        <th style={summaryHeadCellStyle}>
                            <span style={summaryHeadingStyle}>
                                {!hasPlan ? '' : window.translate('Average Weekly OTH')}
                            </span>
                        </th>
                        <th style={summaryHeadCellStyle}>
                            <span style={summaryHeadingStyle}>{!hasPlan ? '' : window.translate('Effective CPT')}</span>
                        </th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td
                            style={{
                                ...summaryBaseCellStyle,
                                paddingLeft: 19.5
                            }}
                        >
                            <span style={summaryHeadingStyle}>{!hasPlan ? '' : window.translate('Base')}</span>
                        </td>
                        <td align='right' style={summaryBaseCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : getTotal('spotCount')}</span>
                        </td>
                        <td align='right' style={summaryBaseCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : getTotal('baseImpacts')}</span>
                        </td>
                        <td align='right' style={summaryBaseCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : planSummary.baseOTH?.toFixed(2)}</span>
                        </td>
                        <td align='right' style={summaryBaseCellStyle}>
                            <span style={summaryTextStyle}>
                                {!hasPlan ? '' : planSummary.baseWeeklyOTH?.toFixed(2)}
                            </span>
                        </td>
                        <td align='right' style={summaryBaseCellStyle}>
                            <span style={summaryTextStyle}>
                                {!hasPlan ? '' : formatCurrency(cpts.effectiveBaseCpt)}
                            </span>
                        </td>
                    </tr>

                    <tr>
                        <td
                            style={{
                                ...summaryTargetCellStyle,
                                paddingLeft: 19.5
                            }}
                        >
                            <span style={summaryHeadingStyle}>{!hasPlan ? '' : window.translate('Target')}</span>
                        </td>
                        <td align='right' style={summaryTargetCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : getTotal('spotCount')}</span>
                        </td>
                        <td align='right' style={summaryTargetCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : getTotal('targetImpacts')}</span>
                        </td>
                        <td align='right' style={summaryTargetCellStyle}>
                            <span style={summaryTextStyle}>{!hasPlan ? '' : planSummary.targetOTH?.toFixed(2)}</span>
                        </td>
                        <td align='right' style={summaryTargetCellStyle}>
                            <span style={summaryTextStyle}>
                                {!hasPlan ? '' : planSummary.targetWeeklyOTH?.toFixed(2)}
                            </span>
                        </td>
                        <td align='right' style={summaryTargetCellStyle}>
                            <span style={summaryTextStyle}>
                                {!hasPlan ? '' : formatCurrency(cpts.effectiveTargetCpt)}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default PlanSummary;
